import React from 'react';
import { useDispatch } from 'react-redux';
import matchList from '@gin-betting/match-list';
import { injectIntl, WrappedComponentProps } from 'react-intl';

import { AsyncOddButton } from 'modules/betslip/async';
import { GetSpecifierHandler } from '../types';
import { getOverAndUnderOdds } from '../../../utils';
import { MarketValue } from '../MarketsValue';
import './MarketTotalOption.scss';
import useMarketTotal from './useMarketTotal';

const { setCustomMarket } = matchList.actions;

interface OwnProps {
    marketId: string;
    topMarketId: string;
    onClick: () => void;
    getSpecifier: GetSpecifierHandler;
    height: number;
    outcomes: Array<{ name: string; value: string }>;
}

type Props = OwnProps & WrappedComponentProps;

const MarketTotalOption: React.FC<Props> = props => {
    const {
        intl: { formatMessage },
        marketId,
        topMarketId,
        onClick: onOptionClick,
        getSpecifier,
        height,
        outcomes,
    } = props;

    const { odds, market } = useMarketTotal({ marketId });
    const dispatch = useDispatch();

    if (!market) {
        return null;
    }

    const { id, specifiers } = market;
    const specifier = getSpecifier(specifiers);

    if (!specifier) {
        return null;
    }

    const { over, under } = getOverAndUnderOdds(odds, formatMessage);

    const onClick = () => {
        dispatch(setCustomMarket({ topMarketId, userMarketId: id }));
        onOptionClick();
    };

    return (
        <div styleName="option" style={{ height }} onClick={onClick}>
            <MarketValue value={specifier.value} />
            <div styleName="button">
                <AsyncOddButton oddId={over.id} showResult={true} />
            </div>
            <div styleName="button">
                <AsyncOddButton oddId={under.id} showResult={true} />
            </div>
        </div>
    );
};

export default injectIntl(MarketTotalOption);
